export default "__VITE_ASSET__JqqcxP0w__"